import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "v-login" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "body" }
const _hoisted_6 = { class: "body__body" }
const _hoisted_7 = { class: "body__footer" }

import CommonInput from "@/components/common/CommonInput.vue";
import CommonButton from "@/components/common/CommonButton.vue";
import { useNotification } from "@/utils/notification";
import { ref } from "vue";
import { authService } from "@/features/auth/auth.service";
import { Eye, EyeOff } from "utruckin-icons";
import { useRouter } from "vue-router";
import { setToken } from "@/utils/token";
import logo from "@/assets/images/logo-auth.svg";


export default /*@__PURE__*/_defineComponent({
  __name: 'AuthView',
  setup(__props) {

const { pushNotification } = useNotification();
const router = useRouter();

const email = ref<string>("");
const password = ref<string>("");
const loading = ref<boolean>(false);
const errorMessage = ref<string>("");
const typeInput = ref<"password" | "text">("password");

const isValidEmail = (val: string) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(val);
};

const login = async () => {
  errorMessage.value = "";

  if (!email.value.trim()) {
    errorMessage.value = "Email is required";
    pushNotification(errorMessage.value, "error");
    return;
  }

  if (!isValidEmail(email.value)) {
    errorMessage.value = "Invalid email format";
    pushNotification(errorMessage.value, "error");
    return;
  }

  if (password.value.length < 6) {
    errorMessage.value = "Password must be at least 6 characters long";
    pushNotification(errorMessage.value, "error");
    return;
  }

  loading.value = true;
  try {
    const { data } = await authService.login({
      email: email.value,
      password: password.value,
    });
    if (data.access_token) {
      const profile = data.profile;

      if (!profile?.role) {
        pushNotification("Unable to load user profile", "error");
        return;
      }

      setToken(data.access_token);

      if (profile.role === "super_admin") {
        localStorage.removeItem("organizationId");
        await router.replace("/organization");
      } else {
        if (!profile.organization_id) {
          pushNotification(
            "Organization is not assigned to this user",
            "error"
          );
          return;
        }

        localStorage.setItem("organizationId", profile.organization_id);
        await router.replace("/all-tasks");
      }

      pushNotification("Login successful", "success");
    }
  } catch (err: any) {
    const message = err?.response?.data?.detail;
    pushNotification(message, "error");
    return;
  } finally {
    loading.value = false;
  }
};

const handleAppendClick = () => {
  if (typeInput.value === "password") {
    typeInput.value = "text";
  } else {
    typeInput.value = "password";
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _unref(logo),
          alt: "company_logo"
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "body__header" }, "Sign in", -1)),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(CommonInput, {
            "model-value": email.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
            label: "Email",
            autocomplete: "email",
            placeholder: "Email"
          }, null, 8, ["model-value"]),
          _createVNode(CommonInput, {
            type: typeInput.value,
            "model-value": password.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
            label: "Password",
            autocomplete: "password",
            placeholder: "Password",
            "append-icon": typeInput.value == 'text' ? _unref(EyeOff) : _unref(Eye),
            onAppendIconClick: handleAppendClick
          }, null, 8, ["type", "model-value", "append-icon"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(CommonButton, {
            onClick: login,
            type: "primary",
            label: "Sign In"
          })
        ])
      ])
    ])
  ]))
}
}

})